<div class="modal">
  <div class="modal-overlay" (click)="close()"></div>

  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <i class="ms-3 bi bi-person"></i>
        <span class="ms-1 modal-title" i18n="@@UserSwitchCustomerDialogHeading">Change your establishment</span>
        <span class="me-auto"></span>
        <i class="btn btn-danger bi bi-x-lg" (click)="close()"></i>
      </div>

      <div class="modal-body">
        <div class="form-floating m-2">
          <select class="form-select" [(ngModel)]="customerUserSelected" required name="userSwitchDialogCustomerUserInput">
            @for (customerUser of customerUserList; track customerUser) {
              <option [ngValue]="customerUser">{{ customerUser | customerNamesToString }}</option>
            }
          </select>
          <label for="userSwitchDialogCustomerUserInput" i18n="@@UserSwitchCustomerDialogCustomerUserLabel">Establishments</label>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="switchUserAsync(customerUserSelected)" [disabled]="customerUserSelected == undefined" i18n="@@UserSwitchCustomerDialogCustomerSwitchButton">Switch</button>
      </div>
    </div>
  </div>
</div>
